// extracted by mini-css-extract-plugin
export default {"testLables":"courseTag_testLables__BkGao","taggedWrap":"courseTag_taggedWrap__dYwvA","taggedCourse":"courseTag_taggedCourse__ia9b2"};